export default __webpack_public_path__ + "static/media/tools-settings.b12d92a7.jpeg";